export default {
  loadingWebsites: "Loading sites...",
  website: "Website",
  websiteLoading: "Loading organisations/institutions",
  guide: {
    show: "See the guide",
  },
  dataAgreement: {
    title: "Update of GDPR-related information",
    save: {
      success: "Data saved successfully!",
    },
    alert_link: "here.",
    alert:
      "As part of the obligations related to GDPR compliance, it is necessary that you fill in the fields below so that the users of your platform can identify you as the data controller. These data will be used to complete the data policy management page of the platform, which you can consult",
  },
};
